import k from '../k'
import addRobot from '../parts/addRobot'
import addUI from '../parts/addUI'
import addVoid from '../parts/addVoid'

k.loadSprite('ui', 'sprites/ui.png')
k.loadSprite('background', 'sprites/background-zero.png')

k.loadSprite('e', 'sprites/tooltip-e.png')

k.loadSprite('flower', 'sprites/flower.png')
k.loadSprite('grass', 'sprites/grass-large.png')
k.loadSprite('door', 'sprites/door.png', {
  sliceX: 2,
  anims: {
    open: 1,
    closed: 0
  }
})

export default () => {
  let doorOpen = false
  let atDoor = false
  let hasFlower = false
  let atFlower = false

  k.setGravity(1000)
  k.add([k.sprite('background'), k.fixed()])

  addVoid(250)

  const { partDisplay } = addUI(0)

  const robot = addRobot(hasFlower, partDisplay)
  const tooltipE = robot.add([k.sprite('e'), k.anchor('bot'), k.pos(0, -12)])
  tooltipE.hidden = true

  const grass = k.add([
    k.sprite('grass'),
    k.pos(-50, 20),
    k.body({ isStatic: true }),
    k.area()
  ])

  const flower = k.add([
    k.sprite('flower'),
    k.pos(50, 20),
    k.area(),
    k.anchor('bot'),
    k.z(10),
    'flower'
  ])
  const door = grass.add([
    k.sprite('door'),
    k.pos(180, 0),
    k.area(),
    k.anchor('bot'),
    k.z(-1),
    'door'
  ])

  robot.onCollide('door', () => {
    atDoor = true
    if (hasFlower) tooltipE.hidden = false
  })
  robot.onCollideEnd('door', () => {
    atDoor = false
    tooltipE.hidden = true
  })

  robot.onCollide('flower', () => {
    atFlower = true
    tooltipE.hidden = false
  })
  robot.onCollideEnd('flower', () => {
    atFlower = false
    tooltipE.hidden = true
  })

  robot.onKeyPress('e', () => {
    if (atDoor && !doorOpen && hasFlower) {
      doorOpen = true
      door.play('open')
    } else if (atFlower && !hasFlower) {
      hasFlower = true
      robot.sprite = 'robot'
      flower.destroy()
    } else if (atDoor && doorOpen) {
      k.go('one')
    }
  })
}
